import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';

class UnlockDatesItem {
  constructor(selectedItems) {
    this.PlanningDetailIds = selectedItems.map((item) => item.PlanningDetailId);
    this.Confirmation = `This will unlock the Start/End dates for ${selectedItems.length} item(s), making them editable again.`;
  }
}

export default class UnlockDatesWindowDescription {
  static titleForCreate = 'Unlock Dates';
  static titleForEdit = 'Unlock Dates';
  static itemType = UnlockDatesItem;
  static serviceFunction = (item) => PlanningDetailsItemService.UnlockDates(item);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Confirm',
      fields: [
        {
          fieldName: 'Confirmation',
          label: 'Are you sure?',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
        },
      ],
    },
  ];
}
